var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import QASection from "../../ui/QASection/QASection";
export var QAModal = function () {
    return (_jsx("div", __assign({ "data-testid": "qa-modal" }, { children: _jsx(QASection, {}) })));
};
export var getQAModalProps = function () {
    return {};
};
